import { css } from 'styled-components';
import type { ITheme } from '../../../utils/theme';

export const getStyledAriaSelectBorder = (
  open: boolean,
  hasError: boolean,
  hasRightDivider: boolean,
  theme: ITheme
) => {
  if (open) {
    return css`
      border: 1px solid ${theme.palette.neutral[70]};
    `;
  }
  if (hasError) {
    return css`
      border: 1px solid ${theme.palette.error.main};
    `;
  }
  if (hasRightDivider) {
    return css`
      border: 1px solid ${theme.palette.neutral[60]};
      border-right: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    `;
  }
  return css`
    border: 1px solid ${theme.palette.neutral[60]};
  `;
};
